var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[(_vm.chartHasData)?[_c('DonutChart',{key:_vm.hashKey,staticClass:"doughnut-chart",attrs:{"chartData":_vm.chartData,"height":190,"width":190}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }